import { render, staticRenderFns } from "./recipientTransferSettings.vue?vue&type=template&id=067a82d2"
import script from "./recipientTransferSettings.vue?vue&type=script&lang=js"
export * from "./recipientTransferSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports